import { Component, HostBinding, input, Input } from "@angular/core";
import { TIconConfig } from "../../utilities/types";

@Component({
    selector: "generic-icon",
    templateUrl: "./generic-icon.component.html",
    styleUrls: ["./generic-icon.component.scss"],
    standalone: false
})
export class GenericIconComponent {
  /**Icon configuration data.*/
  iconConfiguration = input.required<TIconConfig>();
  genericState = input<"flex" | "inline-flex">("flex");
  @HostBinding("style.display") display = this.genericState();
}
